import moment from "moment/moment";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthService from "../AuthService";
import { QueryContext } from "../../App";
const FindIdSuccess = () => {
  const query = useContext(QueryContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [id, setId] = useState("");
  const [reg, setReg] = useState("");
  useEffect(() => {
    getUserId();
  }, []);
  const getUserId = async () => {
    setId(location.state?.id ? location.state.id : "확인불가");
    setReg(
      location.state?.regular_reg_at
        ? moment(location.state.regular_reg_at).format("YYYY년MM월DD일")
        : "확인불가"
    );
  };
  return (
    <div className="find-id-success-page">
      <div className="success-logo">
        <svg
          className="changedone"
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="40" cy="40" r="40" fill="#F2F4F7" />
          <rect
            width="8.79561"
            height="22.3545"
            rx="3"
            transform="matrix(0.709405 -0.704801 0.709405 0.704801 19.168 40.2754)"
            fill="#2373EB"
          />
          <rect
            width="8.79561"
            height="36.113"
            rx="3"
            transform="matrix(0.709482 0.704724 -0.709482 0.704724 54.5898 24.5088)"
            fill="#2373EB"
          />
        </svg>
      </div>
      <div className="items">
        <p className="info">아이디 찾기 완료</p>
        <p className="sub-info">가입한 아이디를 확인해주세요.</p>
        <div>
          <p className="ID">{id ? id : "-"}</p>
          <p className="REGDATE">가입날짜 : {reg}</p>
        </div>
      </div>
      <button
        onClick={() => {
          const redirectItem = sessionStorage.getItem("redirectInfo");
          
          // React Native 웹뷰 감지
          const isReactNativeWebView =
            window.ReactNativeWebView ||
            window.navigator.userAgent.includes("ReactNativeWebView") ||
            window.navigator.userAgent.includes("wv") ||
            (window.navigator.userAgent.includes("Android") &&
              window.navigator.userAgent.includes("wv"));

          // redirect가 있으면 해당 URL로 이동 (웹뷰 유지)
          if (redirectItem && redirectItem !== "null") {
            if (
              redirectItem.startsWith("http://") ||
              redirectItem.startsWith("https://")
            ) {
              window.location.replace(redirectItem);
            } else {
              window.location.replace("http://" + redirectItem);
            }
          } else if (isReactNativeWebView) {
            // redirect가 없고 웹뷰인 경우에만 웹뷰 닫기
            if (window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  type: "CLOSE_WEBVIEW",
                })
              );
            }
          } else {
            // 일반 브라우저에서 redirect 없으면 홈으로
            window.location.replace("http://www.superbin.co.kr");
          }
        }}
      >
        로그인하기
      </button>
    </div>
  );
};
export default FindIdSuccess;
